import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Reminders from '../components/Reminders';
import AllFeatures from '../components/AllFeatures';
import Screenshots from '../components/Screenshots';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

const LandingPage: React.FC = () => (
  <>
    <Hero />
    <Features />
    <Reminders />
    <AllFeatures />
    <Screenshots />
    <Pricing />
    <FAQ />
    <Footer />
  </>
);

export default LandingPage;
